import { render, staticRenderFns } from "./newRelease.vue?vue&type=template&id=0458ae35&scoped=true&"
import script from "./newRelease.vue?vue&type=script&lang=js&"
export * from "./newRelease.vue?vue&type=script&lang=js&"
import style0 from "./newRelease.vue?vue&type=style&index=0&id=0458ae35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0458ae35",
  null
  
)

export default component.exports